import { Vector3 } from "three"

export const toScreenPosition = (obj, camera, renderer) => {
  const vector = new Vector3()
  const canvas = renderer.domElement
  const widthHalf = 0.5 * canvas.offsetWidth
  const heightHalf = 0.5 * canvas.offsetHeight

  obj.updateMatrixWorld()
  vector.setFromMatrixPosition(obj.matrixWorld)
  vector.project(camera)

  vector.x = vector.x * widthHalf + widthHalf
  vector.y = -(vector.y * heightHalf) + heightHalf

  return {
    x: vector.x,
    y: vector.y,
  }
}
